export default {
  REACT_APP_API_ENDPOINT: "https://web-production-bd73.up.railway.app/",
  //REACT_APP_API_ENDPOINT: 'http://localhost:8080/'
};